import axios from "axios";

/**
 * Get the status of a bluViuNutritionR1 or bluViuNutritionR2 for a given site.
 * @param globalSiteId
 * @param scenarioId
 * @returns
 */
export const getScenarioStatus = async (globalSiteId: string, scenarioId: string): Promise<{ scenarioIsRunning: boolean }> => {
    const res = await axios.get<{ scenarioIsRunning: boolean }>(
        `/ewosapi/v1/scenario/status?globalSiteId=${globalSiteId}&scenarioId=${scenarioId}`
    );
    return res.data;
};